import { discount10Icon, discount20Icon, discount25Icon, discountXXIcon } from '../../assets';

export default function getDiscountIconSrc(discountPercent) {
  switch (discountPercent) {
    case 25:
      return discount25Icon;
    case 20:
      return discount20Icon;
    case 10:
      return discount10Icon;
    default:
      return discountXXIcon;
  }
}
